import { useState, useEffect } from 'react';
import { useStore } from './useStore';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../../lib/firebase';

interface Product {
  id: string;
  name: string;
  description: string;
  price: number;
  salePrice: number;
  image: string;
  unit: string;
  stock: number;
  createdAt: any;
}

export function useProduct(productId: string | undefined) {
  const [product, setProduct] = useState<Product | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const { settings } = useStore();

  useEffect(() => {
    async function loadProduct() {
      if (!productId || !settings?.storeId) {
        setLoading(false);
        return;
      }

      try {
        const productRef = doc(db, 'stores', settings.storeId, 'products', productId);
        const productDoc = await getDoc(productRef);

        if (productDoc.exists()) {
          setProduct({
            id: productDoc.id,
            ...productDoc.data()
          } as Product);
        } else {
          setError(new Error('Produto não encontrado'));
        }
      } catch (err) {
        setError(err as Error);
      } finally {
        setLoading(false);
      }
    }

    loadProduct();
  }, [productId, settings?.storeId]);

  return { product, loading, error };
}
